<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label for="status">Статус</label>
          <md-select v-model="value" name="status" id="status" @md-selected="changeFilter" md-dense>
            <md-option v-for="v in items"
                       :value="v.value"
                       :key="v.value">{{ v.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'status',
  data () {
    return {
      items: [
        {name: 'Все', value: 'deleteFilter'},
        {name: 'Активный', value: 1},
        {name: 'Неактивный', value: 0}
      ],
      value: null
    }
  },
  methods: {
    changeFilter () {
      this.$store.commit('setFilter', {name: 'status_id', value: this.value})
      this.$emit('changeFilter')
    }
  },
  created () {
    if (this.$store.state.filtersShop['status_id'] !== null) {
      this.value = this.$store.state.filtersShop.status_id
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/shop/status.vue